module.exports = __webpack_public_path__ + "img/memberFive.d9a205be.svg";